import { initial_state_retailer_report } from "../apps/retailer/RetailerReportsConstants";
import { STOCK_AUDIT_TAB } from "../framework/tab/tabUtilsConstants";
import { getDeepCopy } from "../utils/utils";

const initialState = {
  tabs: [initial_state_retailer_report],
  common: {
    addProduct: {
      formState: {
        allowDiscount: true,
        isReturnable: true,
        isActive: true,
      },
      errorState: [],
      categoryPath: null,
    },
    addBank: {
      formState: null,
      errorState: [],
      categoryPath: null,
    },

    editItemGroup: {
      formState: null,
      errorState: [],
    },
    addDistributor: {
      formState: null,
      errorState: [],
    },
  },
  activeTabIndex: 0,
  configData: {},
};

const commonReducer = (state = initialState, action) => {
  const currentTab = state.tabs[state.activeTabIndex];
  if (action.type === "reset_active_tab") {
    state.tabs[state.activeTabIndex] = action.payload;
    return { ...state };
  }
  if (action.type === "update_active_tab_index") {
    state.activeTabIndex = action.payload;
    return { ...state };
  }
  if (action.type === "update_item_type_options") {
    state.itemTypeOptions = action.payload;
    return { ...state };
  }
  if (action.type === "update_category_options") {
    state.categoryOptions = action.payload;
    return { ...state };
  }
  if (action.type === "update_tabs") {
    state.tabs = action.payload;
    return { ...state };
  }
  if (action.type === "add_report_data_to_redux") {
    state.tabs[state.activeTabIndex] = {
      ...state.tabs[state.activeTabIndex],
      data: action.payload,
    };
    return { ...state };
  }
  if (action.type === "update_current_focus") {
    state.tabs[state.activeTabIndex] = {
      ...state.tabs[state.activeTabIndex],
      currentFocus: action.payload,
    };
    return {
      ...state,
    };
  }
  if (action.type === "refresh_tabs") {
    return initialState;
  }
  if (action.type === "set_config_data") {
    state.tabs[state.activeTabIndex] = {
      ...state.tabs[state.activeTabIndex],
      configData: action.payload,
    };
    return { ...state };
  }
  if (action.type === "active_config_tab") {
    state.tabs[state.activeTabIndex].activeConfigTab = {
      ...action.payload,
    };
    return { ...state };
  }
  if (action.type === "update_config_data") {
    state.tabs[state.activeTabIndex] = {
      ...state.tabs[state.activeTabIndex],
      configData: {
        ...state.tabs[state.activeTabIndex].configData,
        ...action.payload,
      },
    };
    return { ...state };
  }
  if (action.type === "set_add_product_error_state") {
    state.common.addProduct = {
      ...state.common.addProduct,
      errorState: action.payload,
    };
    return { ...state };
  }
  if (action.type === "set_add_product_form_state") {
    state.common.addProduct = {
      ...state.common.addProduct,
      formState: action.payload,
    };
    return { ...state };
  }
  if (action.type === "reset_add_product_form_state") {
    state.common.addProduct = {
      ...state.common.addProduct,
      formState: { ...getDeepCopy(initialState).common.addProduct.formState },
      errorState: [],
      categoryPath: null,
    };
    return { ...state };
  }

  if (action.type === "set_add_bank_form_state") {
    state.common.addBank = {
      ...state.common.addBank,
      formState: {
        ...state.common.addBank.formState,
        ...action.payload,
      },
    };
    return { ...state };
  }

  if (action.type === "set_add_bank_error_state") {
    state.common.addBank = {
      ...state.common.addBank,
      errorState: action.payload,
    };
    return { ...state };
  }

  if (action.type === "reset_add_bank_form_state") {
    state.common.addBank = {
      ...state.common.addBank,
      formState: null,
      errorState: [],
    };
    return { ...state };
  }

  if (action.type === "set_add_distributor_form_state") {
    state.common.addDistributor = {
      ...state.common.addDistributor,
      formState: action.payload,
    };
    return { ...state };
  }
  if (action.type === "set_add_distributor_error_state") {
    state.common.addDistributor = {
      ...state.common.addDistributor,
      errorState: action.payload,
    };
    return { ...state };
  }
  if (action.type === "reset_add_distributor_form_state") {
    state.common.addDistributor = {
      ...state.common.addDistributor,
      formState: null,
      errorState: [],
    };
    return { ...state };
  }
  if (action.type === "update_category_path") {
    state.common.addProduct = {
      ...state.common.addProduct,
      categoryPath: action.payload,
    };
    return { ...state };
  }
  if (currentTab.type === STOCK_AUDIT_TAB) {
    if (action.type === "dispatch_product") {
      let updatedRowData =
        state.tabs[state.activeTabIndex].productRowData.slice();
      let index = action.payload.rowIndex;
      if (action.payload.rowIndex === 0) {
        updatedRowData.push(action.payload.product);
        index = updatedRowData.length - 1;
      } else {
        updatedRowData[action.payload.rowIndex] = action.payload.product;
      }
      state.tabs[state.activeTabIndex] = {
        ...currentTab,
        productRowData: [...updatedRowData],
        lastProductSelectedIndex: index,
      };
      return { ...state };
    }
    if (action.type === "update_product_grid") {
      state.tabs[state.activeTabIndex] = {
        ...currentTab,
        productRowData: [...action.payload],
      };
      return { ...state };
    }
    if (action.type === "update_actors") {
      state.tabs[state.activeTabIndex] = {
        ...currentTab,
        actors: { ...currentTab.actors, ...action.payload },
      };
      return { ...state };
    }
    if (action.type === "update_bill_summary") {
      state.tabs[state.activeTabIndex] = {
        ...currentTab,
        stockAuditSummary: {
          ...currentTab.stockAuditSummary,
          ...action.payload,
        },
      };
      return { ...state };
    }
  }
  return state;
};

export default commonReducer;
